/** @file Wheel zoom of the curve graph about the pointer: both axes, Ctrl value only, Shift time only. */
import { timelineScale } from '@pose2d/editor-geometry/timelineScale';
import type { CurveAxes } from './curveTypes';
import { curveValueScale } from './curveValueScale';

/** Wheel input in canvas CSS pixels; deltaY in pixels (positive = away from the user = zoom out). */
export interface CurveWheel {
  x: number;
  y: number;
  deltaY: number;
  ctrl: boolean;
  shift: boolean;
}

/** New axes after one wheel step: factor exp(−deltaY / 500) per axis, keeping the point under the pointer. */
export function curveWheelAxes(axes: CurveAxes, wheel: CurveWheel): CurveAxes {
  const factor = Math.exp(-wheel.deltaY / 500);
  return {
    time: wheel.ctrl ? axes.time : timelineScale.zoomAt(axes.time, wheel.x, factor),
    value: wheel.shift ? axes.value : curveValueScale.zoomAt(axes.value, wheel.y, factor),
  };
}
